import * as tslib_1 from "tslib";
import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import strings from 'owa-strings/owa-options-strings';
import { QuickOptions } from 'owa-options-view';
import { observer } from 'mobx-react';
var SettingsPane = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsPane, _super);
    function SettingsPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsPane.prototype.render = function () {
        return (React.createElement(HeaderFlexPane, { title: function () { return strings.optionsFlex_title; }, content: React.createElement(QuickOptions, { onDismiss: this.props.onDismiss }), onDismiss: this.props.onDismiss }));
    };
    SettingsPane = tslib_1.__decorate([
        observer
    ], SettingsPane);
    return SettingsPane;
}(React.Component));
export default SettingsPane;
//# sourceMappingURL=SettingsPane.js.map